import { useState, useContext } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import AppContext from "../../contexts/AppContext";
import SessionSelect from "./SessionSelect";
import apiFetch from "../../helperFunctions/api";
import useAsyncAction from "../../helperFunctions/useAsyncAction";
import AddCharacter from "./AddCharacter";
import { useParams } from "react-router-dom";

export default function AddItem({ setSessionData }) {
  const { API, session, getCharacters } = useContext(AppContext);
  const [input, setInput] = useState("");
  const { id } = useParams();
  const [missingCharacter, setMissingCharacter] = useState("");
  const { pending, error, run } = useAsyncAction();
  function parseString() {
    const separator = input.indexOf(":");
    const parts = separator < 0 ? [] : input.slice(separator + 1).split(";");
    if (parts.length < 4 || !parts[0]?.trim() || !/^\d+$/.test(parts[1]) ||
        Number(parts[1]) === 0 || !parts[2]?.trim() || !/^-?\d+$/.test(parts[3])) {
      throw new Error("Paste a complete addon item string with character, item ID, item name, and integer DKP.");
    }
    return { character: parts[0].trim(), itemId: parts[1], itemName: parts[2], dkpAmount: parts[3] };
  }
  return (
    <>
      <SessionSelect />
      {error && <Alert severity="error">{error}</Alert>}
      <TextField disabled={pending} value={input} onChange={(e) => setInput(e.target.value)}
        variant="outlined" label="Add Item to Session" />
      <Button disabled={pending || !input.trim() || !session} variant="outlined" onClick={() => run(async () => {
        const entry = parseString();
        let response;
        try {
          response = await apiFetch(`${API}/session`, {
            method: "POST", headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...entry, sessionName: session, sessionId: id, action: "ADD_ITEM" }),
          });
        } catch (err) {
          if (["Character does not exist.", "Character is not in this session."].includes(err.message)) {
            setMissingCharacter(entry.character);
          }
          throw err;
        }
        setSessionData(await response.json());
        getCharacters();
        setInput("");
      })}>{pending ? "Adding..." : "Add Item"}</Button>
      <Dialog open={Boolean(missingCharacter)} onClose={() => setMissingCharacter("")}>
        <DialogTitle>Add Missing Character?</DialogTitle>
        <DialogContent>
          <AddCharacter key={missingCharacter} character={missingCharacter} setSessionData={setSessionData} />
        </DialogContent>
        <DialogActions><Button onClick={() => setMissingCharacter("")}>Close</Button></DialogActions>
      </Dialog>
    </>
  );
}
